var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12"},[_c('p',{staticClass:"category-label mb-0"},[_vm._v(_vm._s(_vm.item.category))]),_vm._v(" "),_c('p',{staticClass:"subcategory-label text-truncate mb-0"},[_vm._v(_vm._s(_vm.item.subcategory.join(",")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }